import React, { useEffect, useRef } from "react";
import "../css/StrangerThingsPortalOverlay.css";
import demogorgonImg from "../images/demogorgon.png";
import stTheme from "../sounds/stranger-things-theme.mp3";
import demogorgonSfx from "../sounds/demogorgon.mp3";

export default function StrangerThingsPortalOverlay({ active = false, onFinish }) {
  const themeRef = useRef(null);
  const demoRef = useRef(null);

  useEffect(() => {
    if (active) {
      document.body.classList.add("has-overlay");

      const themeEl = themeRef.current;
      const demoEl = demoRef.current;

      if (themeEl) {
        themeEl.currentTime = 0;
        themeEl.volume = 0.8;
        themeEl.play().catch(() => {});
      }

      const demogorgonTimer = setTimeout(() => {
        if (demoEl) {
          demoEl.currentTime = 0;
          demoEl.volume = 0.6;
          demoEl.play().catch(() => {});
        }
      }, 3200);

      const totalAnimationTime = 10000;
      const finishTimer = setTimeout(() => {
        if (onFinish) onFinish();
      }, totalAnimationTime);

      return () => {
        clearTimeout(demogorgonTimer);
        clearTimeout(finishTimer);
        document.body.classList.remove("has-overlay");

        if (themeEl) {
          themeEl.pause();
          themeEl.currentTime = 0;
        }
        if (demoEl) {
          demoEl.pause();
          demoEl.currentTime = 0;
        }
      };
    } else {
      document.body.classList.remove("has-overlay");
    }
  }, [active, onFinish]);

  if (!active) return null;

  return (
    <div id="st-overlay">
      <audio ref={themeRef} src={stTheme} loop />
      <audio ref={demoRef} src={demogorgonSfx} />

      <div className="st-layer st-sky" />
      <div className="st-layer st-cracks st-cracks-back" />
      <div className="st-layer st-cracks st-cracks-front" />
      <div className="st-layer st-fog" />
      <div className="st-layer st-particles" />

      <div className="st-portal-wrapper">
        <div className="st-portal-glow" />
        <div className="st-portal">
          <div className="st-portal-inner" />
        </div>

        <div className="st-demogorgon">
          <img src={demogorgonImg} alt="Demogorgon" className="st-demogorgon-img" />
        </div>
      </div>
    </div>
  );
}